type TAccumulator = { [x: string]: { index: number; count: number } }

/**
 * DISCLAIMER
 * After calculating the percentages (and rounding) for each option, sometimes the sum can be 99% or even 101% percents.
 * The next function is to find an element that can be changed, so the total amount will be 100%.
 */
export const calculatePercent = (array: number[], total = 0): number[] => {
    const percents = array.map(item => item && total && Math.round((item * 100) / total))

    if (total) {
        const checksum = percents.reduce((acc, item) => acc + item, 0) // could be 99, 100, 101

        if (checksum !== 100) {
            const mapped = array.reduce<TAccumulator>((acc, item, index) => {
                if (item in acc) {
                    acc[item] = { ...acc[item], count: acc[item].count + 1 }
                } else {
                    acc[item] = { count: 1, index }
                }
                return acc
            }, {})

            Object.keys(mapped).some(key => {
                if (percents[mapped[key].index] && mapped[key].count === 1) {
                    percents[mapped[key].index] += 100 - checksum
                    return true
                }
                return false
            })
        }
    }
    return percents
}
